import { render, staticRenderFns } from "./DistrictInfo.vue?vue&type=template&id=16baa5c5"
import script from "./DistrictInfo.vue?vue&type=script&lang=js"
export * from "./DistrictInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports